export default {
  namespaced: true,
  state: {
    // ユーザーデータ
    curUserdataConstuctionId: '',
    curUserdataFileList: [],
    curUserdataFolderList: [],
    // 黒板データ
    curKokubandataConstuctionId: '',
    curKokubanDataList: [],
  },
  getters: {
    curUserdataFileList: (state) => (state.curUserdataFileList),
    curKokubanDataList: (state) => (state.curKokubanDataList),
  },
  mutations: {
    putUserdataFolderInfo: (state, payload) => {
      state.curUserdataConstuctionId = payload.cloud_construction_id
      state.curUserdataFileList = payload.file_list
      state.curUserdataFolderList = payload.folder_list
    },
    putKokubanData: (state, payload) => {
      state.curKokubandataConstuctionId = payload.cloud_construction_id
      state.curKokubanDataList = payload.kokuban_data_list
    }
  },
}
